import { TextBase } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

export const EmptyState = ({
  illustration,
  label,
}: {
  illustration: ReactNode;
  label: string;
}) => {
  return (
    <div className="flex flex-col justify-center items-center InfoColoredIcon gap-5 h-full">
      {illustration}
      <div className="text-center w-48">
        <TextBase
          color="text-ds-natural-600"
          label={label}
        />
      </div>
    </div>
  );
};
